import { createSlice } from "@reduxjs/toolkit";

export const cannedResponseSlice = createSlice({
  name: "cannedResponse",
  initialState: {
    getCannedResponseResult: false,
    getCannedResponseLoading: false,
    getCannedResponseError: false,
    addCannedResponseResult: false,
    addCannedResponseLoading: false,
    deleteCannedResponseResult: false,
  },
  reducers: {
    cannedResponseReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_CANNEDRESPONSE":
          return {
            ...state,
            getCannedResponseResult: payload.data,
            getCannedResponseLoading: payload.loading,
            getCannedResponseError: payload.error,
          };
        case "ADD_CANNEDRESPONSE":
          return {
            ...state,
            addCannedResponseResult: payload.data,
            addCannedResponseLoading: payload.loading,
          };
        case "DELETE_CANNEDRESPONSE":
          return {
            ...state,
            deleteCannedResponseResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { cannedResponseReducers } = cannedResponseSlice.actions;

export default cannedResponseSlice.reducer;
